// Models
import { EntityType } from "../EntityType";
/** The entities a custom view can filter on. Filter for any other entity is ignored. */ export const supportedTargetEntities = [
    EntityType.Task
];
/**
 * Built-in field names that are `ITask` properties.
 * `isOnMyDay` is deliberately absent: My Day is per-user state, so it would resolve differently for each member.
 */ const taskPropertyFilterFieldNames = [
    "startDateTime",
    "dueDateTime",
    "finishDateTime",
    "priority",
    "status",
    "bucketId",
    "userAssignments",
    "goalIds"
];
/** The saved built-in filter field for a task's applied categories (labels); not an `ITask` property. */ export const appliedCategoryIdsFilterField = "appliedCategoryIds";
/** Built-in field names that are not a task property. */ const nonTaskPropertyFilterFieldNames = [
    appliedCategoryIdsFilterField
];
/** The built-in field names an expression may use. */ export const customViewBuiltInFilterFieldNames = [
    ...taskPropertyFilterFieldNames,
    ...nonTaskPropertyFilterFieldNames
];
